import {Directive, HostListener, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';

@Directive({
    selector: '[amdMaxNumberGranted]'
})
export class MaxNumberGrantedDirective {
    @Input() public maxNumberGrantedValue: any;
    @Input() public maxNumberGrantedInput: any;
    maxNumberGrantedValueChecking: string;
    exceptions = [
        '-',
        '+',
        ',',
        '.',
        'e',
        'E',
        '-',
    ];

    constructor() {
    }

    @HostListener('keydown', ['$event'])
    onInput(e: any) {
        this.maxNumberGrantedValueChecking = this.maxNumberGrantedValue === null ? '' + e.key : this.maxNumberGrantedValue + e.key;
        if (this.exceptions.includes(e.key) || !this.nextValueCheck(this.maxNumberGrantedValueChecking)) {
            e.preventDefault();
        }
    }

    nextValueCheck(value: string) {
        const res = parseInt(value, 10);
        const isANumber = !isNaN(res);
        if (isANumber && res > this.maxNumberGrantedInput || res < 1) {
            return false;
        }
        return true;
    }
}
